import styled from '@emotion/styled'
import { ScrollstoryDocumentDataBodyLottieSlicePrimary } from '../../../types.generated'
import { getLinkFieldUrl } from '../../data/prismic-helper'
import { InlineCaption, InlineElementContainer } from '../atoms/Atoms'
import { asText } from '@prismicio/client'
import { useEffect, useRef, useState } from 'react'
import { AnimationItem } from 'lottie-web'
import { useInView } from 'react-intersection-observer'
import { useIsPortrait } from '../../util/breakpoints'
import { getPlayingThreshold } from './util'

export interface InlineLottieProps {
  lottie: ScrollstoryDocumentDataBodyLottieSlicePrimary
}

const LottieContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1 0 auto;
  margin-bottom: 0.5em;
`

export const LottieDiv = styled.div`
  width: 100%;
`

export default function InlineLottie(props: InlineLottieProps) {
  const isPortrait = useIsPortrait()
  const data = props.lottie

  const { ref, inView } = useInView({
    threshold: getPlayingThreshold(isPortrait, data),
  })

  const lottieDivRef = useRef<HTMLDivElement>(null)
  const [animation, setAnimation] = useState<AnimationItem | null>(null)
  const [animationPlaying, setAnimationPlaying] = useState<boolean>(false)

  const lottieLink = getLinkFieldUrl(data.lottie)
  const caption = asText(data.media_caption)
  const source = asText(data.media_source)

  if (animation) {
    if (inView) {
      if (!animationPlaying) {
        setAnimationPlaying(true)
        animation.play()
      }
    } else {
      if (animationPlaying) {
        setAnimationPlaying(false)
        animation.pause()
      }
    }
  }

  useEffect(() => {
    if (!lottieLink || !lottieDivRef.current || animation) {
      return
    }

    if (lottieDivRef.current) {
      const newAnimation = window.lottie.loadAnimation({
        path: lottieLink,
        container: lottieDivRef?.current,
        renderer: 'svg',
        loop: data.playback === 'autoplay',
        autoplay: false,
      })

      setAnimation(newAnimation)
    }
  }, [lottieLink, lottieDivRef, data, animation])

  return (
    <InlineElementContainer ref={ref}>
      <LottieContainer>
        <LottieDiv ref={lottieDivRef} />
      </LottieContainer>

      <InlineCaption>
        {caption} <i>{source}</i>
      </InlineCaption>
    </InlineElementContainer>
  )
}
